// Self-contained data for the Hico, Janda & Co., CPAs concept website.
// Sourced from MySiteCare_PH_Law_Accounting_Prospect_Dossiers_WIP/13_Hico_Janda_and_Co_CPAs
// (research snapshot 2026-08-21). The firm's traceable history comes from an older predecessor
// profile under the name "Hico & Hico Accounting Services" — presented explicitly as the
// practice's earlier history, since legal continuity to the current entity is not independently
// confirmed. Historical clients are NOT named, per the dossier's caution against presenting them
// as current endorsements.
export const BIZ = {
  name: "Hico, Janda & Co., CPAs",
  tagline: "Accounting, Tax & Advisory Built on Integrity, Commitment & Competence",
  address: "2nd Floor, Cesha Commercial Building, 1132 Bay-Calauan Highway, Bay, Laguna 4033",
  phone: "+639973644167",
  phoneDisplay: "+63 997 364 4167",
  mapEmbed: "https://www.google.com/maps?q=Cesha+Commercial+Building+Bay-Calauan+Highway+Bay+Laguna&output=embed",
};

export const SERVICE_GROUPS = [
  { title: "Core Accounting", areas: ["Bookkeeping", "Monthly Financial Statements", "Cash-Flow Reporting", "Internal-Control Audit"] },
  { title: "Tax & Compliance", areas: ["Taxation", "Business-Permit Renewals", "Business-Structure Conversion", "Government Representation"] },
  { title: "Advisory", areas: ["Financial Advisory", "Management Advisory", "Budgeting & Forecasting", "Revenue & Expense Analysis"] },
  { title: "Systems & Training", areas: ["Accounting-System Assistance", "Accounting Tutorials & Training"] },
];

export const HISTORY = "Our earlier history, under the name Hico & Hico Accounting Services, traces to founders Arnulfo Bayles Hico Jr., CPA and Kate Hazzle Janda in July 2019. Legal continuity between that earlier practice and Hico, Janda & Co. today has not been independently confirmed — we present this as our background, not a current-entity claim.";

export const FOUNDER = "Our co-founder, Arnulfo Bayles Hico Jr., CPA, holds independently-confirmed public-practice accreditation on PRC records, a BS in Accountancy from Laguna University, and passed the CPA licensure exam in 2017 — with a background spanning private accounting, government accounting (including roles at DOT Region IV-A), property-company finance, and accounting teaching and reviewing.";

export const VALUES = ["Integrity", "Commitment", "Competence"];

export const TEAM_NOTE = "Current professional records associate Maica Bersal, Patricia Nicole Dean Capuchino, Irish Nicole Pitargue and Georgie Ann Villanueva with us.";

export const REPUTATION = {
  rating: "5.0",
  reviewCountLabel: "~5 reviews in public mirrors",
  note: "Individual review text was not recoverable — the rating reflects the aggregate shown in current public listings.",
};
